export const INPUT_NAMES = {
  name: 'nameRef',
  address: 'addressRef',
  phone: 'phoneRef',
  site: 'siteRef',
  inn: 'innRef',
  isBlocked: 'isBlockedRef',
  blockDate: 'blockDateRef',
  partner: 'partnerRef',
  status: 'statusRef',
  packageCount: 'packageCountRef',
  tariffId: 'tariffIdRef',
  subscriptionType: 'subscriptionTypeRef',
  useCustomTariff: 'useCustomTariffRef',
  customTariffReportCount: 'reportCountRef',
  customTariffPriceMonth: 'priceMonthRef',
  customTariffPriceYear: 'priceYearRef',
  customTariffPriceOver: 'priceOverRef',
  dealDate: 'dealDateRef',
  lastPaymentDate: 'lastPaymentDateRef',
} as const
